import PrototypeRecord from './PrototypeRecord';
export default PrototypeRecord;
